var app = angular.module('leonardo');

let VendorService = function(BaseRestService) {
  return new BaseRestService('vendors', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('vendors', false, function(vendor) {
      vendor.addRestangularMethod('contact', 'post', 'contact');
      return vendor;
    });
  });
};

app.factory('VendorService', ['BaseRestService', VendorService]);
